package com.merkost.handpass.sharedweb.theme

object WebBreakpoint {
    const val Narrow = 350
    const val Compact = 360
    const val Mobile = 480
    const val Form = 560
    const val Reading = 680
    const val Tablet = 768
    const val Content = 980
    const val Desktop = 1024
    const val Wide = 1280
}

object WebIconSize {
    const val P12 = 12
    const val P13 = 13
    const val P14 = 14
    const val P15 = 15
    const val P16 = 16
    const val P18 = 18
    const val P20 = 20
    const val P22 = 22
    const val P24 = 24
    const val P26 = 26
    const val P28 = 28
    const val P30 = 30
    const val P40 = 40
    const val P48 = 48
    const val Xs = P12
    const val Sm = P16
    const val Md = P18
    const val Lg = P20
    const val Xl = P24
}

object WebIconStroke {
    const val Thin = 1.5
    const val Light = 1.7
    const val Regular = 1.8
    const val Default = 2.0
    const val Strong = 2.4
}

object WebControlMetrics {
    const val MinTouchTarget = 44
    const val FavoriteTarget = 34
    const val FavoriteGlyph = 16
    const val SearchAction = 40
}

object WebCategoryMetrics {
    const val DefaultIcon = 24
    const val FeatureIcon = 26
}

object WebBrandMetrics {
    const val MarkCompact = 18
    const val MarkHeader = 20
    const val MarkDefault = 22
    const val LedgerFooterWidth = 44
    const val LedgerFooterHeight = 14
    const val LedgerDefaultWidth = 54
    const val LedgerDefaultHeight = 18
    const val LedgerHeroWidth = 66
    const val LedgerHeroHeight = 22
}

object WebAvatarMetrics {
    const val DefaultSize = 32
    const val DefaultFont = 13
}

object WebSkeletonMetrics {
    const val DefaultHeight = 16
    const val DefaultRadius = 6
}

object WebObserverMargin {
    const val ListingPrefetch = "400px"
}

object WebMotionSequence {
    const val GalleryCleanupMs = 220L
    const val ShareFeedbackResetMs = 2_000
    const val ThemeSwapMs = 250
    const val SoldProofBeatMs = 900

    fun cssDelay(delayMs: Int): String = "${delayMs.coerceAtLeast(0)}ms"
}

object WebAsyncTiming {
    const val SearchFocusOutMs = 120
    const val SearchDebounceMs = 300L
    const val LocationSearchDebounceMs = 220L
    const val LocationHintTimeoutMs = 7_000L
}

object WebLayer {
    const val Base = 0
    const val Link = 1
    const val Overlay = 2
    const val Artwork = 6
    const val Section = 20
    const val Floating = 30
}
